import { AllFieldsTable } from "@/components/shared/AllFieldsTable";
import { DocumentPanel } from "@/components/explorer/DocumentPanel";

// Drawer section: every field of the request doc (editable) + every field of its lead_distributions (editable per row).
export function RequestRawData({ r, leads }) {
  return (
    <div className="mt-6 space-y-5" data-testid="request-raw-data">
      <div>
        <h4 className="font-heading font-semibold text-foreground mb-2 text-sm">Every field · <span className="font-mono text-primary">requests/{r.id}</span></h4>
        <DocumentPanel path="requests" id={r.id} />
      </div>
      <div>
        <h4 className="font-heading font-semibold text-foreground mb-2 text-sm">Every field · <span className="font-mono text-primary">lead_distributions</span> where request_id = this lead ({leads.length}) — pencil to edit</h4>
        <AllFieldsTable rows={leads} testId="request-ld-table" path="lead_distributions" />
      </div>
    </div>
  );
}
